import React, { Component } from 'react';
import logo from '../logo.svg';
import '../App.css';
import { Grid, GridCell } from 'rmwc/Grid';
import InputField from '../components/InputField/InputField.js';
import DataTable from '../components/Table/Table.js';
import { Typography } from 'rmwc/Typography';
import { Button } from 'rmwc/Button';
import { Slider } from 'rmwc/Slider';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { List, ListItem } from 'rmwc/List';
import { Card } from 'rmwc/Card';
import { Elevation } from 'rmwc/Elevation';

import { Toolbar, ToolbarRow, ToolbarSection, ToolbarMenuIcon, ToolbarTitle, ToolbarIcon } from 'rmwc';
import Navbar from '../components/Navbar/Navbar.js';
import ResultList from '../components/ResultList/ResultList';
import Result from '../components/Result/Result.js';
import GetHorizontalIrradiance from '../utils/GlobalHorizontal.js';
import GetTiltIrradiance from '../utils/GlobalTilt.js';
import GetMaxTemp from '../utils/MaxTemp.js';
import GetMaxNoSun from '../utils/MaxNoSun.js';
import EnergyForm from '../components/EnergyForm/EnergyForm';
import EnergyList from '../components/EnergyList/EnergyList';
import Sizing from '../utils/Sizing';
import { Chip, ChipText, ChipIcon, ChipSet } from 'rmwc/Chip';


import { BrowserRouter as Router, Route } from "react-router-dom";
import Auth from '../Auth/Auth.js';

let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

let energyItems = [];
energyItems.push({ index: 3, value: "BTS 350 Ericsson", power: 500, voltage: 48, hours: 24, done: false });
energyItems.push({ index: 2, value: "MW Dishes", power: 340, voltage: 48, hours: 24, done: true });
energyItems.push({ index: 1, value: "Battery cabinet", power: 2000, voltage: 48, hours: 8, done: true });


class Home extends Component {
  login() {
    this.props.auth.login();
  }


  constructor(props) {
    super(props);

    this.state = {
      userDevice: '',
      list: [],
      months: [],
      currentInputs: [],
      irradianceData: months,
      energyItems: energyItems
    };
    this.collectInputs = this.collectInputs.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  dailyEnergy = () => {
    let energy = []
    let myArr = this.state.energyItems
    for (let i = 0; i < myArr.length; i++) {
      let subTotal = (parseFloat(myArr[i]['power']) * parseFloat(myArr[i]['hours']) / 1000).toFixed(2);
      energy.push(subTotal);
    }
    console.log("typeof: ", typeof energy[0]);
    console.log("array:", myArr);
    console.log("energy:", energy);
    this.setState({ dailyEnergy: Math.sum(...energy) });
  }

  addItem(energyItem) {
    energyItems.unshift({
      index: energyItems.length + 1,
      value: energyItem.newItemValue,
      voltage: energyItem.newVoltage,
      power: energyItem.newPower,
      hours: energyItem.newHours,
      done: false
    });
    this.setState({ energyItems: energyItems });
  }

  removeItem(itemIndex) {
    energyItems.splice(itemIndex, 1);
    this.setState({ energyItems: energyItems });
  }

  markEnergyInactive(itemIndex) {
    let energy = energyItems[itemIndex];
    energyItems.splice(itemIndex, 1);
    energy.done = !energy.done;
    energy.done ? energyItems.push(energy) : energyItems.unshift(energy);
    this.setState({ energyItems: energyItems });
  }

  collectInputs(lat, lon, sliderValue2, energy, storage, battVoltage, battCapacity, panelSize, dod, value) {
    let inputs = [];
    for (let i = 0; i < arguments.length; i++) {
      inputs.push(arguments[i]);
    }

    this.setState({ currentInputs: inputs });
    //expreimenting Promis.all
    Promise.all([GetHorizontalIrradiance(parseInt(lat), parseInt(lon)), GetTiltIrradiance(parseInt(lat), parseInt(lon)), GetMaxTemp(parseInt(lat), parseInt(lon)), GetMaxNoSun(parseInt(lat), parseInt(lon))]).then(values => {
      console.log(values);
      let data2 = [];
      for (let i = 0; i < 12; i++) {
        data2.push({ month: months[i] });
      };
      for (let i = 0; i < 12; i++) {
        data2[i]['horizontal'] = values[0]['irradiance'][i];
        data2[i]['tilt'] = values[1]['irradiance'][i];
        data2[i]['maxtemp'] = values[2]['temp'][i];
        data2[i]['nosun'] = values[3]['nosun'][i];
      }
      console.log("this is the state of energyItems:", this.state.energyItems);
      console.log("Input array: ", this.state.currentInputs)
      this.setState({ irradianceData: data2 })
    })
  }

  dailyEnergy = () => {
    (this.state.energyItems.map(item => Number(item['power']) * Number(item['hours']))).reduce((total, amount) => total + amount, 0) / 1000
  }

  render() {
    const { isAuthenticated } = this.props.auth;
    return (
      <div>
        {
          isAuthenticated() && (
            <div className="App">
              <Card><EnergyForm addItem={this.addItem} /></Card>
              <Grid>
                <GridCell span="12">
                  <EnergyList
                    items={this.state.energyItems}
                    removeItem={this.removeItem} markEnergyInactive={this.markEnergyInactive}
                    totalDailyEnergy={(this.state.energyItems.map(item => Number(item['power']) * Number(item['hours']))).reduce((total, amount) => total + amount, 0) / 1000}
                  />
                </GridCell>
                <GridCell span="12">
                  <Elevation z="3">
                    <Toolbar>
                      <ToolbarRow style={{ backgroundColor: '#4caf50' }}>
                        <ToolbarTitle>Daily energy requirement: {(Sizing.TotalEnergy(this.state.energyItems) / 1000).toFixed(2)} kWh ({(this.state.energyItems.map(item => Number(item['power']) * Number(item['hours']))).reduce((total, amount) => total + amount, 0) / 1000} kWh)</ToolbarTitle>
                      </ToolbarRow>
                    </Toolbar>
                  </Elevation>
                </GridCell>
                <GridCell span="12">
                  <Card><InputField getInput={this.collectInputs} /></Card>
                </GridCell>
                <GridCell span="12">
                  <Elevation z="3">
                    <Toolbar>
                      <ToolbarRow style={{ backgroundColor: '#4caf50' }}>
                        <ToolbarTitle>Results</ToolbarTitle>
                      </ToolbarRow>
                    </Toolbar>
                  </Elevation>
                </GridCell>
                <GridCell span="12">
                  <Card>
                    <ResultList
                      minRad={Math.min(...this.state.irradianceData.map(rad => rad['tilt']))}
                      avgAnnual={((this.state.irradianceData.map(rad => Number(rad['tilt']))).reduce((total, amount) => total + amount, 0) / 12).toFixed(2)}
                      numPanels={Sizing.numPanels(
                        //panelSize, roofMount, maxTemp, positioning, energyItems, worstTiltRad
                        Number(this.state.currentInputs[8]),
                        this.state.currentInputs[10],
                        Number(Math.max(...this.state.irradianceData.map(rad => rad['maxtemp']))),
                        0, // Postitioning considered as best
                        this.state.energyItems,
                        Number(Math.min(...this.state.irradianceData.map(rad => rad['tilt'])))
                      )}
                      optTilt={Sizing.optTilt(this.state.currentInputs[0])}
                      numBatt={Sizing.battStorage(
                        this.state.currentInputs[6],
                        this.state.currentInputs[2],
                        this.state.currentInputs[5],
                        this.state.currentInputs[3],
                        this.state.currentInputs[10],
                        Number(Math.max(...this.state.irradianceData.map(rad => rad['maxtemp']))),
                        0,
                        this.state.energyItems,
                        Number(Math.min(...this.state.irradianceData.map(rad => rad['tilt'])))
                      )}

                    /><br /></Card>
                </GridCell>
              </Grid>
              <br />
              <DataTable irrData={this.state.irradianceData} />
              <Toolbar>
                <ToolbarRow style={{ backgroundColor: '#4caf50' }}>
                  <ToolbarTitle><Typography use="caption">Copyright © 2019 - {new Date().getFullYear()}  Kisfali Engineering AS. All rights reserved</Typography></ToolbarTitle>
                </ToolbarRow>
              </Toolbar>
            </div>
          )
        }
        {
          !isAuthenticated() && (
            <Grid>
              <GridCell span="12">
                <Typography use="headline">
                  You are not logged in. Please login to use the app!
                </Typography>
              </GridCell>
              <GridCell span="12">
                <Button stroked onClick={this.login.bind(this)}>Login</Button>
              </GridCell>
            </Grid>
          )
        }
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home/Home.js